/**
 * <s-reveal>: fades and lifts its [data-reveal] descendants into place the first
 * time the element enters the viewport. Children stagger via the `--reveal-i`
 * custom property. Without JS, or with reduced motion, content is simply visible.
 */
class SReveal extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    this.setAttribute('data-armed', '');
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.setAttribute('data-revealed', '');
          this.#observer?.disconnect();
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.01 },
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('s-reveal')) customElements.define('s-reveal', SReveal);
